/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * Device Management
 * Device Manager API CRUD https://bitbucket.org/nwaveio/device-management-openapi/src/master/
 *
 * The version of the OpenAPI document: 2.1.5
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * @export
 * @interface LabelCreateFields
 */
export interface LabelCreateFields {
    /**
     * Names String. For example zone name, group name or custom_id
     * @type {string}
     * @memberof LabelCreateFields
     */
    label: string;
    /**
     * `Only Admin can use this field` *Readonly for another users*
     * @type {number}
     * @memberof LabelCreateFields
     */
    owner_id?: number;
}
